// import React, { useRef, useState } from "react";
// import styled from "styled-components";
// import { useLocation, useNavigate } from "react-router-dom";
// import { FaArrowLeft, FaPlay } from "react-icons/fa";
// import Navbar from "./Navbar";
// import DashboardHeader from "./DashboardHeader";
// import Footer from "./Footer";
// import { useTheme } from "../App";

// const Container = styled.div`
//   --sidebar-expanded: 260px;
//   --sidebar-collapsed: 90px;
  
//   --page-bg: ${({ $isDarkMode }) => $isDarkMode ? 'linear-gradient(180deg, #0f172a 0%, #1e293b 100%)' : 'linear-gradient(180deg, #f8fafc 0%, #edf4ff 100%)'};
//   --card-bg: ${({ $isDarkMode }) => $isDarkMode ? '#1e293b' : 'rgba(255, 255, 255, 0.94)'};
//   --text-main: ${({ $isDarkMode }) => $isDarkMode ? '#f8fafc' : '#0f172a'};
//   --text-soft: ${({ $isDarkMode }) => $isDarkMode ? '#94a3b8' : '#64748b'};
//   --border: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(148, 163, 184, 0.18)'};

//   min-height: 100vh;
//   background: var(--page-bg);
//   color: var(--text-main);
//   margin-left: ${({ collapsed }) => collapsed ? "var(--sidebar-collapsed)" : "var(--sidebar-expanded)"};
//   transition: margin-left 0.3s ease, background 0.3s ease, color 0.3s ease;

//   @media (max-width: 1024px) { margin-left: ${({ collapsed }) => (collapsed ? "78px" : "220px")}; }
//   @media (max-width: 768px) { margin-left: 0; }
// `;

// const Main = styled.main`
//   width: min(1000px, calc(100% - 32px));
//   margin: 0 auto;
//   padding: 24px 0 40px;
// `;

// const BackButton = styled.button`
//   background: transparent;
//   border: none;
//   display: flex;
//   align-items: center;
//   gap: 8px;
//   color: var(--text-soft);
//   font-size: 1rem;
//   font-weight: 700;
//   cursor: pointer;
//   margin-bottom: 24px;
//   transition: color 0.2s;

//   &:hover {
//     color: #7c3aed;
//   }
// `;

// const PlayerCard = styled.div`
//   background: var(--card-bg);
//   border: 1px solid var(--border);
//   border-radius: 24px;
//   overflow: hidden;
//   box-shadow: 0 15px 35px rgba(0,0,0,0.1);
// `;

// const VideoWrapper = styled.div`
//   position: relative;
//   width: 100%;
//   padding-top: 56.25%; /* 16:9 Aspect Ratio */
//   background: #000;
  
//   video {
//     position: absolute;
//     top: 0;
//     left: 0;
//     width: 100%;
//     height: 100%;
//   }
// `;

// const CustomPlayOverlay = styled.div`
//   position: absolute;
//   inset: 0;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   background: rgba(0, 0, 0, 0.4);
//   cursor: pointer;
//   z-index: 10;
//   transition: opacity 0.3s ease;
  
//   /* Hides overlay when video is playing */
//   opacity: ${({ $isPlaying }) => $isPlaying ? 0 : 1};
//   pointer-events: ${({ $isPlaying }) => $isPlaying ? 'none' : 'auto'};
// `;

// const PlayCircle = styled.div`
//   width: 80px;
//   height: 80px;
//   background: #7c3aed;
//   border-radius: 50%;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   color: white;
//   font-size: 32px;
//   box-shadow: 0 10px 25px rgba(124, 58, 237, 0.5);
//   transition: transform 0.2s ease;

//   ${CustomPlayOverlay}:hover & {
//     transform: scale(1.1);
//   }
// `;

// const VideoDetails = styled.div`
//   padding: 24px 32px;
// `;

// const Title = styled.h2`
//   margin: 0;
//   font-size: 1.5rem;
//   font-weight: 800;
//   color: var(--text-main);
// `;

// const VideoPlayer = ({ user, collapsed, setCollapsed }) => {
//   const { isDarkMode } = useTheme();
//   const location = useLocation();
//   const navigate = useNavigate();
//   const videoRef = useRef(null);
//   const [isPlaying, setIsPlaying] = useState(false);

//   // Extract the video object passed from the previous page
//   const video = location.state?.video;

//   // Fallback if accessed directly without clicking a video card
//   if (!video) {
//     return (
//       <Container collapsed={collapsed} $isDarkMode={isDarkMode}>
//         <Main><p>Video not found. Please go back and select a video.</p></Main>
//       </Container>
//     );
//   }

//   const handlePlayClick = () => {
//     if (videoRef.current) {
//       videoRef.current.play();
//       setIsPlaying(true);
//     }
//   };

//   return (
//     <Container collapsed={collapsed} $isDarkMode={isDarkMode}>
//       <Navbar user={user} collapsed={collapsed} setCollapsed={setCollapsed} />
//       {/* <DashboardHeader user={user} collapsed={collapsed} title="Now Playing" /> */}

//       <Main>
//         <BackButton onClick={() => navigate(-1)}>
//           <FaArrowLeft /> Back to Messages
//         </BackButton>

//         <PlayerCard>
//           <VideoWrapper>
//             <video 
//               ref={videoRef}
//               src={video.url} 
//               poster={video.thumb}
//               controls={isPlaying} // Show native controls only after play is clicked
//               onPause={() => setIsPlaying(false)}
//               onPlay={() => setIsPlaying(true)}
//             />
            
//             {/* Custom Play Button Overlay */}
//             <CustomPlayOverlay $isPlaying={isPlaying} onClick={handlePlayClick}>
//               <PlayCircle>
//                 <FaPlay style={{ marginLeft: '6px' }} />
//               </PlayCircle>
//             </CustomPlayOverlay>
            
//           </VideoWrapper>

//           <VideoDetails>
//             <Title>{video.title}</Title>
//           </VideoDetails>
//         </PlayerCard>
//       </Main>
//       <Footer />
//     </Container>
//   );
// };

// export default VideoPlayer;



import React, { useRef, useState, useEffect } from "react";
import styled from "styled-components";
import { useLocation, useNavigate } from "react-router-dom";
import { FaArrowLeft, FaPlay, FaFileAlt } from "react-icons/fa";
import Navbar from "./Navbar";
import DashboardHeader from "./DashboardHeader";
import Footer from "./Footer";
import { useTheme } from "../App";

/* ================= MOCK DATA ================= */
const relatedVideosData = [
  { id: 4, title: "The Heart of a Servant Leader", thumb: "https://picsum.photos/id/1025/600/340", url: "https://www.w3schools.com/html/mov_bbb.mp4", duration: "12:40" },
  { id: 5, title: "Building a Culture of Excellence", thumb: "https://picsum.photos/id/1043/600/340", url: "https://www.w3schools.com/html/mov_bbb.mp4", duration: "45:15" },
  { id: 6, title: "Effective Communication in Ministry", thumb: "https://picsum.photos/id/1050/600/340", url: "https://www.w3schools.com/html/mov_bbb.mp4", duration: "28:30" },
];

const articlesData = [
  { id: 1, title: "5 Pillars of Ministry Leadership", excerpt: "Discover the foundational attributes every leader must cultivate to inspire and guide their team effectively...", date: "Oct 12, 2023" },
  { id: 2, title: "Time Management for the Modern Minister", excerpt: "Balancing pastoral care, administrative duties, and personal growth requires a strategic approach to your daily schedule.", date: "Nov 04, 2023" },
];

/* ================= STYLED COMPONENTS ================= */
const Container = styled.div`
  --sidebar-expanded: 260px;
  --sidebar-collapsed: 90px;
  
  --page-bg: ${({ $isDarkMode }) => $isDarkMode ? 'linear-gradient(180deg, #0f172a 0%, #1e293b 100%)' : 'linear-gradient(180deg, #f8fafc 0%, #edf4ff 100%)'};
  --card-bg: ${({ $isDarkMode }) => $isDarkMode ? '#1e293b' : 'rgba(255, 255, 255, 0.94)'};
  --text-main: ${({ $isDarkMode }) => $isDarkMode ? '#f8fafc' : '#0f172a'};
  --text-soft: ${({ $isDarkMode }) => $isDarkMode ? '#94a3b8' : '#64748b'};
  --border: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(148, 163, 184, 0.18)'};

  min-height: 100vh;
  background: var(--page-bg);
  color: var(--text-main);
  margin-left: ${({ collapsed }) => collapsed ? "var(--sidebar-collapsed)" : "var(--sidebar-expanded)"};
  transition: margin-left 0.3s ease, background 0.3s ease, color 0.3s ease;

  @media (max-width: 1024px) { margin-left: ${({ collapsed }) => (collapsed ? "78px" : "220px")}; }
  @media (max-width: 768px) { margin-left: 0; }
`;

// Widen the main container to fit two columns
const Main = styled.main`
  width: min(1280px, calc(100% - 32px));
  margin: 0 auto;
  padding: 24px 0 40px;
`;

const BackButton = styled.button`
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-soft);
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  margin-bottom: 24px;
  transition: color 0.2s;

  &:hover {
    color: #7c3aed;
  }
`;

// Two-column layout grid
const LayoutGrid = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 32px;
  align-items: start;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
`;

const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

/* Player Styles */
const PlayerCard = styled.div`
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 15px 35px rgba(0,0,0,0.1);
`;

const VideoWrapper = styled.div`
  position: relative;
  width: 100%;
  padding-top: 56.25%; /* 16:9 Aspect Ratio */
  background: #000;
  
  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;

const CustomPlayOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.4);
  cursor: pointer;
  z-index: 10;
  transition: opacity 0.3s ease;
  
  opacity: ${({ $isPlaying }) => $isPlaying ? 0 : 1};
  pointer-events: ${({ $isPlaying }) => $isPlaying ? 'none' : 'auto'};
`;

const PlayCircle = styled.div`
  width: 80px;
  height: 80px;
  background: #7c3aed;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 32px;
  box-shadow: 0 10px 25px rgba(124, 58, 237, 0.5);
  transition: transform 0.2s ease;

  ${CustomPlayOverlay}:hover & {
    transform: scale(1.1);
  }
`;

const VideoDetails = styled.div`
  padding: 24px 32px;
`;

const Title = styled.h2`
  margin: 0;
  font-size: 1.5rem;
  font-weight: 800;
  color: var(--text-main);
`;

/* Shared Section Titles */
const SectionTitle = styled.h3`
  font-size: 1.25rem;
  font-weight: 800;
  color: var(--text-main);
  margin: 0 0 16px 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

/* Related Videos Styles */
const RelatedVideoList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const RelatedVideoCard = styled.div`
  display: flex;
  gap: 12px;
  cursor: pointer;
  padding: 8px;
  border-radius: 12px;
  transition: background 0.2s;

  &:hover {
    background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)'};
  }
`;

const RelatedThumbWrap = styled.div`
  position: relative;
  width: 140px;
  height: 80px;
  flex-shrink: 0;
  border-radius: 8px;
  overflow: hidden;
  background: #000;
`;

const RelatedThumb = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.9;
  transition: opacity 0.2s;

  ${RelatedVideoCard}:hover & {
    opacity: 1;
  }
`;

const DurationBadge = styled.div`
  position: absolute;
  bottom: 4px;
  right: 4px;
  background: rgba(0,0,0,0.8);
  color: white;
  font-size: 0.7rem;
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 600;
`;

const RelatedInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

const RelatedTitle = styled.h4`
  margin: 0 0 6px 0;
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--text-main);
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

/* Articles Styles */
const ArticlesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
`;

const ArticleCard = styled.div`
  background: var(--card-bg);
  border: 1px solid var(--border);
  padding: 24px;
  border-radius: 16px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.03);
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 25px rgba(0,0,0,0.08);
  }
`;

const ArticleDate = styled.span`
  font-size: 0.8rem;
  font-weight: 700;
  color: #7c3aed;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

const ArticleTitle = styled.h4`
  font-size: 1.1rem;
  font-weight: 800;
  color: var(--text-main);
  margin: 8px 0;
  line-height: 1.4;
`;

const ArticleExcerpt = styled.p`
  font-size: 0.95rem;
  color: var(--text-soft);
  margin: 0 0 16px 0;
  line-height: 1.5;
`;

const ReadMore = styled.a`
  font-size: 0.9rem;
  font-weight: 700;
  color: #7c3aed;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

/* ================= COMPONENT ================= */
const VideoPlayer = ({ user, collapsed, setCollapsed }) => {
  const { isDarkMode } = useTheme();
  const location = useLocation();
  const navigate = useNavigate();
  const videoRef = useRef(null);
  
  const [isPlaying, setIsPlaying] = useState(false);
  const video = location.state?.video;

  // Reset play state and scroll to top when video changes
  useEffect(() => {
    setIsPlaying(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [video?.id]);

  if (!video) {
    return (
      <Container collapsed={collapsed} $isDarkMode={isDarkMode}>
        <Main><p>Video not found. Please go back and select a video.</p></Main>
      </Container>
    );
  }

  const handlePlayClick = () => {
    if (videoRef.current) {
      videoRef.current.play();
      setIsPlaying(true);
    }
  };

  const handleRelatedClick = (relatedVideo) => {
    navigate(`/videoplayer/${relatedVideo.id}`, { state: { video: relatedVideo } });
  };

  return (
    <Container collapsed={collapsed} $isDarkMode={isDarkMode}>
      <Navbar user={user} collapsed={collapsed} setCollapsed={setCollapsed} />

      <Main>
        <BackButton onClick={() => navigate(-1)}>
          <FaArrowLeft /> Back to Messages
        </BackButton>

        <LayoutGrid>
          {/* LEFT COLUMN: Player & Articles */}
          <LeftColumn>
            <PlayerCard>
              <VideoWrapper>
                <video 
                  key={video.id} // Forces re-render of video element on route change
                  ref={videoRef}
                  src={video.url} 
                  poster={video.thumb}
                  controls={isPlaying} 
                  onPause={() => setIsPlaying(false)}
                  onPlay={() => setIsPlaying(true)}
                />
                
                <CustomPlayOverlay $isPlaying={isPlaying} onClick={handlePlayClick}>
                  <PlayCircle>
                    <FaPlay style={{ marginLeft: '6px' }} />
                  </PlayCircle>
                </CustomPlayOverlay>
              </VideoWrapper>

              <VideoDetails>
                <Title>{video.title}</Title>
              </VideoDetails>
            </PlayerCard>

            {/* RECOMMENDED ARTICLES */}
            <div>
              <SectionTitle><FaFileAlt style={{ color: '#7c3aed' }}/> Recommended Reading</SectionTitle>
              <ArticlesGrid>
                {articlesData.map(article => (
                  <ArticleCard key={article.id}>
                    <ArticleDate>{article.date}</ArticleDate>
                    <ArticleTitle>{article.title}</ArticleTitle>
                    <ArticleExcerpt>{article.excerpt}</ArticleExcerpt>
                    <ReadMore>Read Article →</ReadMore>
                  </ArticleCard>
                ))}
              </ArticlesGrid>
            </div>
          </LeftColumn>

          {/* RIGHT COLUMN: Related Videos Sidebar */}
          <RightColumn>
            <SectionTitle>Up Next</SectionTitle>
            <RelatedVideoList>
              {relatedVideosData.map(vid => (
                <RelatedVideoCard 
                  key={vid.id} 
                  $isDarkMode={isDarkMode}
                  onClick={() => handleRelatedClick(vid)}
                >
                  <RelatedThumbWrap>
                    <RelatedThumb src={vid.thumb} alt={vid.title} />
                    <DurationBadge>{vid.duration}</DurationBadge>
                  </RelatedThumbWrap>
                  <RelatedInfo>
                    <RelatedTitle>{vid.title}</RelatedTitle>
                  </RelatedInfo>
                </RelatedVideoCard>
              ))}
            </RelatedVideoList>
          </RightColumn>
        </LayoutGrid>

      </Main>
      <Footer />
    </Container>
  );
};

export default VideoPlayer;